import React, { SVGProps } from 'react';
import { COLOR_PALETTE } from 'app/constants/ColorPalette';

interface IProps extends SVGProps<SVGSVGElement> {
  color?: string;
  backgroundColor?: string;
}

/* eslint-disable max-len */
const SvgPen: React.FunctionComponent<IProps> = ({
  color = COLOR_PALETTE.grey.darker,
  backgroundColor = COLOR_PALETTE.grey.white,
  ...props
}) => (
  <svg viewBox="0 0 1590 1590" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle fill={backgroundColor} cx={795} cy={795} r={795} />
      <path
        d="M667.68 739.1l188 187.93-121.19 121.14a123.04 123.04 0 01-14.4 12.32l.32.34c-29.81 22.05-51 37-63.55 44.81-33.05 20.58-58.84 31.37-75.91 38.15-40.2 15.96-109.47 30.21-126.52 30.21-17.05 0-33.43-14.13-33.43-33.98 0-19.84 8.5-75 33.43-134.38 9.88-23.54 20.92-51.4 38.99-79 7.25-11.1 19.97-27.22 38.13-48.4a122.46 122.46 0 0114.86-18c.02 0 .03-.02.08 0l121.19-121.13zM847.7 431.9l63.65 63.63 39.5-39.5c47.69-47.58 124.9-47.58 172.58 0l15.43 15.43c47.7 47.6 47.71 124.85.08 172.5-.02.01-.03.03-.08 0l-249.7 249.6-188-187.93L845.9 560.96l-28.12-28.11-128.87 128.82c-8.6 8.58-22.52 8.58-31.12 0l-35.1-35.1c-8.6-8.57-8.6-22.5-.01-31.1h.01l159.93-159.86c1-1 2.09-1.89 3.22-2.66l1.05-1.05c16.8-16.77 44.02-16.77 60.82 0z"
        fill={color}
      />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgPen;
